import React from 'react';
import { Building } from 'lucide-react';
import { Business } from '../../../types/graphql';
import { getImageUrl } from '../../../utils/imageUrl';

interface PartnerHeaderProps {
  partner: Pick<Business, 'companyName' | 'logo' | 'sector'>;
}

const PartnerLogo = ({ logo, companyName }: { logo: string | null | undefined, companyName: string }) => {
  const [hasError, setHasError] = React.useState(false);

  if (!logo || hasError) {
    return (
      <div className="w-24 h-24 bg-gray-100 rounded-lg flex items-center justify-center">
        <Building className="w-12 h-12 text-gray-400" />
      </div>
    );
  }

  return (
    <img
      src={getImageUrl(logo)}
      alt={companyName}
      className="w-24 h-24 object-contain rounded-lg border border-gray-200"
      onError={() => setHasError(true)}
    />
  );
};

export default function PartnerHeader({ partner }: PartnerHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <PartnerLogo logo={partner.logo} companyName={partner.companyName} />
        </div>
        <div className="ml-4">
          <h1 className="text-2xl font-bold">{partner.companyName}</h1>
          <p className="text-gray-600">Secteur: {partner.sector}</p>
        </div>
      </div>
    </div>
  );
}